
interface Props{
    quantity?: number
    loading: boolean
}
export function UserSearchLoadingSend({ quantity = 6, loading }: Props){
    return (
        <>
            {loading ? (
                <>
                    {[...Array(quantity)].map((_, index) => (
                        // <div key={index} className="row-notification open-notification row-user">
                        //     <span className="user-select-none col-1 img-account-search img-notification placeholder"/>
                        //     <div className="col" style={{ paddingLeft: "5px", overflow: "hidden",  }}>
                        //         <h5 className="h5-name-search name-card-search-user" style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
                        //             <span className="name-search" style={{ marginRight: 5 }}>
                        //             <div className="placeholder" style={{height: "10px", width: "90%"}}></div>
                        //             </span>
                        //         </h5>
                        //         <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                        //             <span className="placeholder mt-1" style={{height: "10px", width: "100px"}}></span>
                        //         </p>
                        //     </div>
                        // </div>
                        <div
                            key={index}
                            className={`smc-person-item `}
                        >
                            <div className="smc-person-avatar-wrap">
                                {/* <img
                                    src={getImageUser(person?.img_account)}
                                    className="smc-person-avatar"
                                    onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}
                                /> */}
                                <span className="smc-person-avatar placeholder"/>
                            </div>
                            <span className="smc-person-label placeholder" style={{ height: "10px", width: "100%" }}/>
                        </div>
                    ))}
                </>
            ) : null }
        </>
    );
}